/* import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import FingerprintJS from "@fingerprintjs/fingerprintjs";

function Home() {

    const { celebrityId } = useParams();

    const [message, setMessage] = useState("Preparing your profile...");


    useEffect(() => {
        if (!celebrityId) {
            return;
        }
        startShareFlow();
    }, [celebrityId]);


    const generateReferrer = () => {
        return (Math.random().toString(36).substring(2, 10) + Date.now().toString(36));
    };


    const detectPlatform = () => {

        const ua = navigator.userAgent || navigator.vendor || window.opera || "";

        if (/Android/i.test(ua)) {
            return "android";
        }

        if (/iPhone|iPad|iPod/i.test(ua) || (/Macintosh/i.test(ua) && navigator.maxTouchPoints && navigator.maxTouchPoints > 1)) {
            return "ios";
        }
        return "web";
    };


    const startShareFlow = async () => {
        const platform = detectPlatform();
        console.log("Platform:", platform);

        const referrer = generateReferrer();
        console.log("Generated referrer:", referrer);

        // Save locally
        localStorage.setItem("share_referrer", referrer);

        localStorage.setItem("share_celebrity", celebrityId);
        try {

            // =========================
            // FINGERPRINT
            // =========================
            let fingerprint = null;
            try {
                const fp = await FingerprintJS.load();
                const result = await fp.get();
                fingerprint = result?.visitorId || null;
            } catch (fingerprintError) {
                console.log("Fingerprint error:", fingerprintError);
            }


            // =========================
            // TRACK CLICK
            // =========================

            await axios.get(`https://meetwithcelebrity.com/api/v1/users/trackUserClick/${celebrityId}`,
                {
                    params: {
                        fingerprint,
                        referrer,
                        platform
                    }
                }
            );


            console.log("Click tracked successfully");
        } catch (error) {
            console.log("Tracking API error:", error);
            // IMPORTANT:
            // Tracking failure should NOT
            // prevent app opening.
        }


        // =========================
        // OPEN APPLICATION
        // =========================

        openApplication(celebrityId, referrer, platform);
    };


    const openApplication = (celebrityId, referrer, platform) => {
        if (platform === "web") {
            setMessage("Opening celebrity profile...");
            window.location.replace(`https://meetwithcelebrity.com/celebrity/${celebrityId}`);
            return;
        }


        const appUrl = `meetcelebrity://celebrity/${celebrityId}` + `?referrer=${encodeURIComponent(referrer || "")}`;
        console.log("Trying to open app:", appUrl);
        setMessage("Opening app...");

        let appOpened = false;


        // =========================
        // DETECT PAGE LEAVING
        // =========================

        const handleVisibilityChange = () => {
            if (document.hidden) {
                appOpened = true;
                console.log("Application appears to have opened");
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        // =========================
        // TRY APP
        // =========================
        window.location.href = appUrl;

        // =========================
        // FALLBACK
        // =========================
        setTimeout(() => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
            if (appOpened || document.hidden) {
                console.log("App opened successfully");
                return;
            }
            console.log("App was not opened");

            if (platform === "android") {
                setMessage("Opening Play Store...");
                window.location.replace("https://play.google.com/store/apps/details?id=com.meetwithcelebrity");
            } else if (platform === "ios") {
                setMessage("Opening App Store...");
                window.location.replace("https://apps.apple.com/in/app/mwc-meet-with-celebrity/id6775950358");
            }
        }, 2500);
    };


    return (
        <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", fontFamily: "Arial" }}>
            <div style={{ width: 45, height: 45, border: "4px solid #ddd", borderTop: "4px solid #000", borderRadius: "50%", animation: "spin 1s linear infinite" }} />

            <h3 style={{ marginTop: 20 }}>{message}</h3>

            <p>Please wait...</p>

            <style>
                {`
                    @keyframes spin {
                        0% {
                            transform: rotate(0deg);
                        }

                        100% {
                            transform: rotate(360deg);
                        }
                    }
                `}
            </style>
        </div>
    );

}
export default Home; */

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import FingerprintJS from "@fingerprintjs/fingerprintjs";


function Home() {

    const { celebrityId } = useParams();
    const [message, setMessage] = useState("Preparing your profile...");

    useEffect(() => {
        if (!celebrityId) {
            return;
        }
        startShareFlow();
    }, [celebrityId]);

    // =====================================
    // GENERATE REFERRER
    // =====================================
    const generateReferrer = () => {
        if (window.crypto && window.crypto.randomUUID) {
            return window.crypto.randomUUID();
        }
        return (Date.now().toString(36) + Math.random().toString(36).substring(2, 15));
    };


    // =====================================
    // GET / CREATE REFERRER
    // =====================================
    const getOrCreateReferrer = (celebrityId) => {
        const storageKey = "celebrity_referrals";
        let referrals = {};
        try {
            referrals = JSON.parse(localStorage.getItem(storageKey) || "{}");
        } catch (error) {
            referrals = {};
        }

        // SAME CELEBRITY
        if (referrals[celebrityId]) {
            return referrals[celebrityId];
        }

        // NEW CELEBRITY
        const referrer = generateReferrer();
        referrals[celebrityId] = referrer;
        localStorage.setItem(storageKey, JSON.stringify(referrals));
        return referrer;
    };

    // =====================================
    // PLATFORM
    // =====================================
    const detectPlatform = () => {

        const ua = navigator.userAgent || navigator.vendor || window.opera || "";
        if (/Android/i.test(ua)) {
            return "android";
        }
        if (/iPhone|iPad|iPod/i.test(ua) || (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1)) {
            return "ios";
        }
        return "web";
    };

    // =====================================
    // START
    // =====================================
    const startShareFlow = async () => {
        const platform = detectPlatform();
        console.log("Platform:", platform);

        // =================================
        // REFERRER
        // =================================
        const referrer = getOrCreateReferrer(celebrityId);


        console.log("Referrer:", referrer);

        // =================================
        // FINGERPRINT
        // =================================
        let fingerprint = null;
        try {
            const fp = await FingerprintJS.load();
            const result = await fp.get();
            fingerprint = result?.visitorId || null;
        } catch (error) {
            console.log("Fingerprint error:", error);
        }

        // =================================
        // TRACK CLICK
        // =================================
        let clickId = null;
        try {
            const response = await axios.get(`https://meetwithcelebrity.com/api/v1/users/trackUserClick/${celebrityId}`, { params: { fingerprint, referrer, platform } });
            clickId = response?.data?.data?.clickId || null;
            console.log("Click ID:", clickId);
        } catch (error) {
            console.log("Tracking API error:", error);
        }

        // =================================
        // OPEN
        // =================================
        openApplication(celebrityId, referrer, clickId, platform);
    };

    // =====================================
    // OPEN APPLICATION
    // =====================================
    const openApplication = (celebrityId, referrer, clickId, platform) => {

        // =================================
        // WEB
        // =================================
        if (platform === "web") {
            setMessage("Opening celebrity profile...");
            window.location.replace(`https://meetwithcelebrity.com/celebrity/${celebrityId}`);
            return;
        }

        // =================================
        // APP URL
        // =================================
        const params = new URLSearchParams();
        params.set("referrer", referrer || "");

        if (clickId) {
            params.set("clickId", clickId);
        }
        const appUrl = `meetcelebrity://celebrity/${celebrityId}?${params.toString()}`;

        console.log("Trying:", appUrl);
        setMessage("Opening app...");

        let appOpened = false;
        const handleVisibilityChange = () => {
            if (document.hidden) {
                appOpened = true;
            }
        };
        document.addEventListener("visibilitychange", handleVisibilityChange);

        // =================================
        // OPEN APP
        // =================================
        window.location.href = appUrl;

        // =================================
        // FALLBACK
        // =================================
        setTimeout(() => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
            if (appOpened || document.hidden) {
                console.log("App opened");
                return;
            }

            // =================================
            // PLAY STORE
            // =================================
            if (platform === "android") {
                setMessage("Opening Play Store...");
                const playReferrer = new URLSearchParams({
                    referrer: referrer || "",
                    celebrityId: celebrityId || "",
                    clickId: clickId || ""
                }).toString();
                const playStoreUrl = `https://play.google.com/store/apps/details?id=com.meetwithcelebrity&referrer=${encodeURIComponent(playReferrer)}&celebrityId=${celebrityId}&clickId=${clickId}`;


                window.location.replace(playStoreUrl);
            }

            // =================================
            // APP STORE
            // =================================
            else if (platform === "ios") {
                setMessage("Opening App Store...");
                window.location.replace("https://apps.apple.com/in/app/mwc-meet-with-celebrity/id6775950358");
            }
        }, 2500);
    };

    return (
        <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", fontFamily: "Arial" }}>
            <div style={{ width: 45, height: 45, border: "4px solid #ddd", borderTop: "4px solid #000", borderRadius: "50%", animation: "spin 1s linear infinite" }} />
            <h3 style={{ marginTop: 20 }}>{message}</h3>

            <p>Please wait...</p>
            <style>
                {`
                    @keyframes spin {
                        0% {
                            transform: rotate(0deg);
                        }
                        100% {
                            transform: rotate(360deg);
                        }
                    }
                `}
            </style>
        </div>
    );
}

export default Home;